import axios from 'axios'

import { getApiUrl } from '#/shared/lib/constants'

import { ChatSearchResponse } from '../model/types'

export const CHAT_SEARCH_LIMIT = 8

export class ChatSearchRequestError extends Error {
	status: number

	constructor(status: number) {
		super('Chat search request failed')
		this.status = status
	}
}

export async function searchChats(params: {
	q: string
	token?: string
	limit?: number
	signal?: AbortSignal
}): Promise<ChatSearchResponse> {
	try {
		const { data } = await axios.get<ChatSearchResponse>(getApiUrl() + '/api/chats/search/', {
			params: { q: params.q, limit: params.limit ?? CHAT_SEARCH_LIMIT },
			signal: params.signal,
			headers: {
				Authorization: `Bearer ${params.token}`,
			},
		})
		return data
	} catch (error) {
		if (axios.isCancel(error)) {
			throw error
		}
		if (axios.isAxiosError(error)) {
			throw new ChatSearchRequestError(error.response?.status ?? 0)
		}
		throw error
	}
}
